// In a module of its own so tests can replace it: a real navigation would take
// the test runner's page away with it.
export function redirectToLogin() {
  window.location.href = `${window.location.origin}/login`;
}
